import Phaser from 'phaser';
import { AssetKeys } from '../assetKeys';
import { WORLD_WIDTH } from '../layout';

/** M0 skeleton mine: sky + one placeholder hero sprite. */
export class MineScene extends Phaser.Scene {
  constructor() {
    super('Mine');
  }

  create(): void {
    const sky = this.add.image(0, 0, AssetKeys.bgMeadowSky).setOrigin(0, 0);
    sky.setDisplaySize(WORLD_WIDTH, 640);

    const hero = this.add.image(WORLD_WIDTH / 2, 560, AssetKeys.heroBase);
    hero.setOrigin(0.5, 1);
    hero.setScale(0.4);

    this.cameras.main.setBounds(0, 0, WORLD_WIDTH, 1200);
    this.cameras.main.centerOn(WORLD_WIDTH / 2, 400);

    // Visual tests wait on this instead of a fixed sleep / canvas-only race.
    (window as unknown as { __BURROW_READY__?: boolean }).__BURROW_READY__ = true;
  }
}
